import React from "react"
import types from "prop-types"
import { questionShape, sectionShape } from "utils/propTypeShapes"
import { AnsweredFormOverviewContextProvider } from "contexts/AnsweredFormOverviewContext"
import AnsweredFormOverviewSections from "./AnsweredFormOverviewSections"
import AnsweredFormOverviewDeletedQuestions from "./AnsweredFormOverviewDeletedQuestions"

const DEFAULT_DELETED_QUESTIONS_NOTE = "The following questions were removed."

const AnsweredFormOverview = ({
  answers = {},
  className = "",
  deletedQuestionsNote = DEFAULT_DELETED_QUESTIONS_NOTE,
  deletedQuestions = [],
  flaggedQuestionUuids = [],
  newQuestionUuids = [],
  postSectionsContent = null,
  sections = [],
}) => (
  <AnsweredFormOverviewContextProvider
    answers={answers}
    deletedQuestionsNote={deletedQuestionsNote}
    deletedQuestions={deletedQuestions}
    flaggedQuestionUuids={flaggedQuestionUuids}
    newQuestionUuids={newQuestionUuids}
    sections={sections}
  >
    <div className={className}>
      <AnsweredFormOverviewSections />
      {postSectionsContent}
      <AnsweredFormOverviewDeletedQuestions />
    </div>
  </AnsweredFormOverviewContextProvider>
)

AnsweredFormOverview.propTypes = {
  answers: types.object,
  className: types.string,
  deletedQuestionsNote: types.string,
  deletedQuestions: types.arrayOf(questionShape),
  flaggedQuestionUuids: types.arrayOf(types.string),
  newQuestionUuids: types.arrayOf(types.string),
  postSectionsContent: types.node,
  sections: types.arrayOf(sectionShape),
}

export default AnsweredFormOverview
